export default __webpack_public_path__ + "static/cosmetic_paragraph_image-ce9d0c1ba87ea1a8f9f9ed146da49496.webp";